import { render, staticRenderFns } from "./QueryObjectAddNew.vue?vue&type=template&id=da96005c"
import script from "./QueryObjectAddNew.vue?vue&type=script&lang=js"
export * from "./QueryObjectAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports